import React from "react";
import DataSection from "../components/sections/Data.jsx";
import { data } from "../constants/yemekcom/data.js";
import SliderSection from "../components/sections/Slider.jsx";
import { icerikler } from "../constants/yemekcom/icerikler.js";
import { kategoriler } from "../constants/yemekcom/kategoriler.js";
import { projeler } from "../constants/yemekcom/projeler.js";
import { display } from "../constants/yemekcom/display.js";
import { videolar } from "../constants/yemekcom/videolar.js";
import { useLanguage } from "../contexts/LanguageContext";

export default function Yemekcom() {
  const { language } = useLanguage();

  return (
    <div className="flex flex-col">
      <img
        src={
          language === "TR"
            ? "https://srv-cdn.onedio.com/store/bbbccafc5a05327ea0bc57db611bb0d1dc02457866e0c348b8ad6d0480ae92b0.png"
            : "https://srv-cdn.onedio.com/store/8699d329043de28fac6010f9a35889759e415e086f6392991184df2b7ccfd530.jpg"
        }
        className="w-full max-w-[1440px] mx-auto"
        alt=""
      />
      <DataSection data={data} title="Datalar" name="datalar" />
      <SliderSection
        className={"bg-[#fdf2f0]"}
        data={icerikler}
        circle={false}
        name="icerikler"
      />
      <SliderSection
        className={"bg-[#F3FCF6]"}
        data={kategoriler}
        circle={false}
        name="kategoriler"
      />
      <SliderSection
        className={"bg-[#FEF9F3]"}
        data={projeler}
        circle={false}
        name="projeler"
      />
      <SliderSection
        className={"bg-[#F3FCF6]"}
        data={videolar}
        circle={false}
        name="videolar"
      />
      <SliderSection
        className={"bg-[#ffefdd]"}
        data={display}
        circle={false}
        name="display"
      />
    </div>
  );
}
